
<template>
    <div class="row">
         <div class="col-md-4 mb-1">
            <label class="form-label">Marka</label>
            <v-validator :errors="errors" parameter="VehicleBrandId" :watch="brand">
                <v-select-list v-model="brand" label="Name" placeholder="Marka" :options="brands" img="Logo"></v-select-list>
            </v-validator>
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Model</label>
            <v-validator :errors="errors" parameter="VehicleBrandModelId" :watch="brandModel">
                <v-select-list v-model="brandModel" label="Name" placeholder="Model" :disabled="!brand" :options="brandModels"/>
            </v-validator>
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Seri</label>
            <v-validator :errors="errors" parameter="VehicleBrandModelSerialId" :watch="brandModelSerial">
                <v-select-list v-model="brandModelSerial" placeholder="Seri" :disabled="!brandModel" label="Name" :options="brandModelSerials"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Araç Tipi</label>
            <v-validator :errors="errors" parameter="VehicleTypeId" :watch="vehicleType">
                 <v-select-list v-model="vehicleType" label="Name" placeholder="Araç Tipi" :options="vehicleTypes" img="Image"></v-select-list>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Model Yılı</label>
            <v-validator :errors="errors" parameter="VehicleModelYear" :watch="year">
                <v-select-list v-model="year" label="Name" placeholder="Model Yılı" :options="years"/>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1" v-if="isTrailer">
            <label class="form-label">Ad Blue Kapasitesi (LT)</label>
            <v-validator :errors="errors" parameter="AdBlueCapacity" :watch="value.AdBlueCapacity">
                <input type="text" class="form-control" placeholder="Ad Blue Kapasitesi (LT)" v-model="value.AdBlueCapacity"/>
            </v-validator>
        </div>

        <div class="col-md-6 mb-1" v-if="isTrailer">
            <label class="form-label">Yakıt Depo-1 Kapasitesi (LT)</label>
            <v-validator :errors="errors" parameter="FuelTankCapacity1" :watch="value.FuelTankCapacity1">
                <input type="text" class="form-control" placeholder="Yakıt Depo-1 Kapasitesi (LT)" v-model="value.FuelTankCapacity1"/>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1" v-if="isTrailer">
            <label class="form-label">Yakıt Depo-2 Kapasitesi (LT)</label>
            <v-validator :errors="errors" parameter="FuelTankCapacity2" :watch="value.FuelTankCapacity2">
                <input type="text" class="form-control" placeholder="Yakıt Depo-2 Kapasitesi (LT)" v-model="value.FuelTankCapacity2"/>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1" v-if="isTrailer">
            <label class="form-label">Yakıt Tipi</label>
            <v-validator :errors="errors" parameter="FuelTypeId" :watch="fuelType">
                <v-select-list v-model="fuelType" label="VisibleName" placeholder="Yakıt Tipi" :options="fuelTypes"/>
            </v-validator>
            
        </div>
        <div class="col-md-6 mb-1" v-if="isTrailer">
            <label class="form-label">Emisyon Türü</label>
            <v-validator :errors="errors" parameter="EmissionTypeId" :watch="emissionType">
                <v-select-list v-model="emissionType" label="Name" placeholder="Emisyon Türü" :options="emissionTypes"/>
            </v-validator>

        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Boş Ağırlık (TON)</label>
            <v-validator :errors="errors" parameter="EmptyWeight" :watch="value.EmptyWeight">
                <input type="text" class="form-control" placeholder="Boş Ağırlık (TON)" v-model="value.EmptyWeight"/>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Dolu Ağırlık (TON)</label>
            <v-validator :errors="errors" parameter="MaxNotEmptyWeight" :watch="value.MaxNotEmptyWeight">
                <input type="text" class="form-control" placeholder="Dolu Ağırlık (TON)" v-model="value.MaxNotEmptyWeight"/>
            </v-validator>
        </div>
       
    </div>
</template>

<script>
import VehicleDefinitionsApi from '@/api/vehicle-definitions'
import SystemDataApi from '@/api/system-data'
import Additional from '@/utilities/additional'
export default {
    props:{
        value:Object,
        errors:Object
    },
    components:{
    },
    mounted(){
        this.getVehicleBrands()
        this.getVehicleBrandModels()
        this.getVehicleBrandModelSerials()
        this.getVehicleTypes()
        this.getFuelTypes()
        this.getEmissionTypes()
        this.getLastYears(35)
    },
    data(){
        return{
            brands:[],
            brandModels:[],
            brandModelSerials:[],
            vehicleTypes:[],
            fuelTypes:[],
            emissionTypes:[],
            years:[],
        }
    },
    methods:{
        getLastYears(lastYearCount){
            var date = new Date,
            years = [],
            year = date.getFullYear();

            for (var i = year-lastYearCount; i <= year; i++) {
                years.push(i);   
            }
            this.years = years;
        },
        getVehicleTypes(){
            VehicleDefinitionsApi.Type.List()
            .then(res=>{
                this.vehicleTypes = Additional.ConvertNestedDataToSingleData(res.data.Data,"Name","Id","ParentVehicleTypeId",['Image','IsTrailer'])
            })
        },
        getVehicleBrands(){
            VehicleDefinitionsApi.Brand.List()
            .then(res=>{
                this.brands = res.data.Data
            })
        },
        getVehicleBrandModels(){
            if(this.value.VehicleBrandId){
                VehicleDefinitionsApi.BrandModel.ListByBrandId(this.value.VehicleBrandId)
                .then(res=>{
                    this.brandModels = res.data.Data
                })
            }
            
        },
        getVehicleBrandModelSerials(){
            if(this.value.VehicleBrandModelId){
                VehicleDefinitionsApi.BrandModelSerial.ListByBrandModelId(this.value.VehicleBrandModelId)
                .then(res=>{
                    this.brandModelSerials = res.data.Data
                })
            }
            
        },
        getFuelTypes(){
            SystemDataApi.FuelType()
            .then(res=>{
                this.fuelTypes = res.data.Data
            })
        },
        getEmissionTypes(){
            SystemDataApi.EmissionType()
            .then(res=>{
                this.emissionTypes = res.data.Data
            })
        },
    },
    watch:{
        "value.VehicleBrandId"(nevV,oldV){
            if(nevV != oldV){
                this.getVehicleBrandModels()
                this.brandModels = []
                this.brandModel = null
            }
        },
        "value.VehicleBrandModelId"(nevV,oldV){
            if(nevV != oldV){
                this.getVehicleBrandModelSerials()
                this.brandModelSerials = []
                this.brandModelSerial = null
            }
        },
        "value.VehicleTypeId"(newV,oldV){
            if(newV != oldV){
                this.value.AdBlueCapacity = null
                this.value.FuelTankCapacity1 = null
                this.value.FuelTankCapacity2 = null
                this.value.FuelTypeId = null
                this.value.EmissionTypeId = null

            }
        }
    },
    computed:{
        brand:{
            get:function(){
                return this.brands.find(b=>b.Id==this.value.VehicleBrandId)
            },
            set:function(value){
                this.value.VehicleBrandId = value?.Id || null
            }
        },
        brandModel:{
            get:function(){
                return this.brandModels.find(s=>s.Id==this.value.VehicleBrandModelId)
            },
            set:function(value){
                this.value.VehicleBrandModelId = value?.Id || null
            }
        },
        brandModelSerial:{
            get:function(){
                return this.brandModelSerials.find(s=>s.Id==this.value.VehicleBrandModelSerialId)
            },
            set:function(value){
                this.value.VehicleBrandModelSerialId = value?.Id || null
            }
        },
        vehicleType:{
            get:function(){
                return this.vehicleTypes.find(s=>s.Id==this.value.VehicleTypeId)
            },
            set:function(value){
                this.value.VehicleTypeId = value?.Id || null
            }
        },
        emissionType: {
            get:function(){
                return this.emissionTypes.find(s=>s.Id==this.value.EmissionTypeId)
            },
            set:function(value){
                this.value.EmissionTypeId = value?.Id || null
            }
        },
        fuelType: {
            get:function(){
                return this.fuelTypes.find(s=>s.Id==this.value.FuelTypeId)
            },
            set:function(value){
                this.value.FuelTypeId = value?.Id || null
            }
        },
        year:{
            get:function(){
                return this.year=this.value.VehicleModelYear
            },
            set:function(value){
                this.value.VehicleModelYear = value || null
            }
        },
        isTrailer(){
            return this.vehicleType ? !this.vehicleType.IsTrailer : false
        }
    }
}
</script>

<style lang="scss">
</style>